<template>
  <f7-page>
  </f7-page>
</template>

<script>
  // import {errorMessageAlert} from '@/helpers/alert'
  import Spinner from '@/components/common/spinner'
  import {loadPage} from '@/helpers/routing'

  export default {
    name: 'RedirectionPageOTP',
    // props: ['email', 'otp', 'ressource'],
    props: {
      email: {
        type: String,
        default: ''
      },
      otp: {
        type: String,
        default: ''
      },
      ressource: {
        type: String,
        default: ''
      }
    },
    components: {
      'spinner': Spinner
    },
    data: () => {
      return {
        details: undefined,
        serviceId: '1',
        fromIdToServiceParam: {
          '1': 'payments',
          '2': 'directDebit',
          '6': 'directPayments',
          '7': 'businessDocuments',
          '8': 'suppliers'
        },
        specificRessources: [
          'paymentFromApplication',
          'sendDocumentsFromApplication'
        ]
      }
    },
    created () {
      let that = this
      let email = this.email
      let otp = this.otp
      let ressource = this.ressource
      let iframe = this.iframe
      if (email === '' && otp === '' && ressource === '') {
        email = new URL(location.href).searchParams.get('email')
        otp = new URL(location.href).searchParams.get('OTP')
        ressource = new URL(location.href).searchParams.get('ressource')
        iframe = new URL(location.href).searchParams.get('iframe')
        if (new URL(location.href).searchParams.get('sendDocumentsFromApplication')) {
          ressource = 'sendDocumentsFromApplication'
        } else if (new URL(location.href).searchParams.get('paymentFromApplication')) {
          ressource = 'paymentFromApplication'
        }
      }

      if (this.specificRessources.includes(ressource)) {
        this.logInWithOTP(email, otp)
        /* POUR REDIRECTION VERS IFRAME LMSG */
          .then((response) => {
            if (ressource === 'paymentFromApplication') {
              that.$engine.services.suppliers.selectedInvoice = {
                ref: new URL(location.href).searchParams.get('ref'),
                amount: new URL(location.href).searchParams.get('amount'),
                currency: new URL(location.href).searchParams.get('currency'),
                name: new URL(location.href).searchParams.get('name'),
                description: new URL(location.href).searchParams.get('description'),
                username: new URL(location.href).searchParams.get('username'),
                client: {
                  name: new URL(location.href).searchParams.get('clientName'),
                  address: new URL(location.href).searchParams.get('clientAddress'),
                  zipCode: new URL(location.href).searchParams.get('clientZipCode'),
                  city: new URL(location.href).searchParams.get('clientCity')
                },
                seller: {
                  name: new URL(location.href).searchParams.get('sellerName'),
                  address: new URL(location.href).searchParams.get('sellerAddress'),
                  zipCode: new URL(location.href).searchParams.get('sellerZipCode'),
                  city: new URL(location.href).searchParams.get('sellerCity')
                }
              }
            }
            setTimeout(function () { /* Timeout for letting time to load vue components */
              loadPage(that, {url: '/' + ressource + '/'})
            }, 2000)
          })
      } else {
        this.logInWithOTP(email, otp)
        /* POUR REDIRECTION VERS DEALPRUDENCE */
          .then((response) => {
            setTimeout(function () { /* Timeout for letting time to load vue components */
              that.$engine.services.payments.update(0, 10, 1, undefined, ressource)
              .then(response => {
                if (response.data.payments.length === 0) {
                  throw new Error('No ressource')
                }
                that.$engine.settings.set({
                  clickedMessage: response.data.payments[0]
                })
                that.$engine.settings.set({
                  msgFromInbox: true
                })
                if (iframe) {
                  loadPage(that, {url: `/payments/transaction-details-demo/`})
                } else {
                  loadPage(that, {url: `/payments/transaction-details/`})
                }
              })
              .catch(err => {
                loadPage(that, {url: '/home/'})
              })
              .finally(() => {
                if (iframe) {
                  that.$bus.$emit('login', 'iframe')
                } else {
                  that.$bus.$emit('login', true)
                }
              })
            }, 1000)
          })
          // A décommenter quand les OTP seront utilisables sur les autres services
          /* .then((response) => {
            setTimeout(function () {
              // In case the redirection from getRequestsList fails, retry in 1 second
              if (that.serviceId === '2') {
                that.loadDetailsPage(response.data.directDebits[0])
              } else if (that.serviceId === '7') {
                that.loadDetailsPage(response.data.groups[0])
              }
            }, 1000)
          }) */
      }
    },
    methods: {
      /**
       * Log in to DealPrudence with an otp
       * @param {{email: String}} - of the user to log
       * @param {{otp: String}} - one time password of the user to log
       *
       * @return Promise
       */
      logInWithOTP (email, otp) {
        let that = this
        // this.$f7.showPreloader(this.$i18n.t('loginPage.sign_in_loading'))
        return this.$engine.auth.loginOTP({ email: email, otp: otp })
          .then(resp => {
            that.details = {}
            if (resp.status === 200) {
              // this.$f7.hidePreloader()
              // this.initDealPrudenceMenus()
              // let connectedModal = this.$f7.modal({
              //   title: this.$i18n.t('loginPage.guest_session', {email: email}),
              //   text: this.$i18n.t('loginPage.guest_redirecting')
              // })
              // setTimeout(function () {
              //   that.$f7.closeModal(connectedModal)
              // }, 2000)
              return resp
            } else {
              this.failed(new Error('OTP expired'), 'Connection failed', 'Your OTP password is expired', [
                {
                  text: 'Email me a new OTP code.',
                  onClick: function () {
                  }
                }
              ])
            }
          })
          .catch(err => {
            // this.$f7.hidePreloader()
            throw new Error(err)
            // this.failed(err, 'Failed to connect with OTP', '', [
            //   {
            //     text: 'Close',
            //     onClick: function () {
            //       that.$bus.$emit('logout', true)
            //       // that.$engine.user.unload()
            //       loadPage(that, { url: '/login/' })
            //     }
            //   }
            // ])
            // errorMessageAlert(err, that)
          })
      },
      /**
       * Get the directDebit by its notification code
       * As of 11/08/2020 this returns only directDebit of direction 0 !
       * @param {{ressource: String}} - coressponds to cm_dealprudence.notification_instance.code
       *
       * @return Promise
       */
      getRequestsList (ressource) {
        let that = this
        return that.$engine.services[this.fromIdToServiceParam[this.serviceId]].update(0, 10, 1, undefined, ressource)
          .then(resp => {
            setTimeout(function () {
              let dataToShow = {}
              if (that.serviceId === '2') {
                dataToShow = resp.data.directDebits[0]
              } else if (that.serviceId === '7') {
                dataToShow = resp.data.Documents[0]
              }
              that.loadDetailsPage(dataToShow)
            }, 1000)
            return resp
          })
          .catch(err => {
            this.failed(err, 'Failed to retrieve ressource')
          })
      },
      /**
       * Changes page to directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       *
       * @return Promise
       */
      loadDetailsPage (message) {
        let that = this
        this.setDetailsPageEngineParams(message)
        if (this.serviceId === '7') {
          this.$bus.$emit('login', true)
          loadPage(that, {url: that.loadDetailsPageGetUrl(message.direction)})
        } else {
          return this.$engine.services.notificationRead(this.ressource)
            .then(resp => {
              this.$bus.$emit('login', true)
              loadPage(that, {url: that.loadDetailsPageGetUrl(message.direction)})
              return resp
            })
            .catch(err => {
              console.error('Failed to set notification read')
              throw err
            })
        }
      },
      /**
       * Sets parameters required by the engine to loadPage directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       */
      setDetailsPageEngineParams (message) {
        if (this.serviceId === '2') {
          message.direction = '0'
          this.$engine.services.directDebit.currentInbox = message
        }
        if (this.serviceId === '7') {
          this.$engine.services.businessDocuments.currentSendbox = message
        }
      },
      /**
       * Get the url from the engine to loadPage directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       * @param {{isReceived: String}} - always true (dont ask)
       *
       * @return redirection url
       */
      loadDetailsPageGetUrl (direction) {
        let redirectionUrl = {
          '1': '/payments/transaction-details/',
          '2': '/directDebit/details/',
          '6': '/directPayments/details/',
          '7': '/inbox/'
        }
        let UrlToReturn = redirectionUrl[this.serviceId]
        if (this.serviceId !== '7') {
          UrlToReturn += direction + '/'
        }
        return UrlToReturn
      },
      /**
       * Shows an error modal to the user and throws the error in js
       * @param {{error: Error}} - error to be thrown
       * @param {{title: String}} - Title of the modal
       * @param {{description: String}} - Description of the modal
       * @param {{buttons: Array}} - Buttons of the modal (check the method logInWithOTP for an example or the f7 documentation about modals)
       *
       * @throws error
       */
      failed (error, title, description = '', buttons = []) {
        this.$f7.hidePreloader()
        this.$f7.modal({
          title: title,
          text: description,
          verticalButtons: true,
          buttons: buttons
        })
        throw error
      },
      initDealPrudenceMenus () {
        this.$bus.emit('login', 'SendDocumentsFromApplication')
        this.$bus.emit('refresh-cache-menu')
        this.$engine.user.changeService(this.$engine.services.get()[parseInt(this.serviceId) - 1])
        this.$bus.emit('service:change', this.$t(this.$engine.services.getNameFromServiceId(this.serviceId)))
        this.$engine.user.currentService.id = this.serviceId
      }
    }
  }
</script>

<style>
</style>
